<template>
    <div class="p-8 text-center mt-16 bg-slate-300 absolute bottom-0 w-full">
        <p>Designed &amp; Powered by
            <b><a href="https://cesp.skuuni.com" style="color: #763C4B" target="_blank">SKUUNI</a></b>
            {{ ' ' }}
            <span>&copy;</span>
            {{ new Date().getFullYear() }}
        </p>
    </div>
</template>